(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
      this.menuCards = this.menuCards || this.header.querySelectorAll('menu-cards-item');
      this.menuCards.forEach((item) => item.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class MenuCardsItem extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.trigger = this.querySelector('.header__menu-item');
      this.panel = this.querySelector('.menu-cards');
      this.openTimer = null;
      this.closeTimer = null;
      this.tapped = false;

      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.addEventListener('focusin', this.open.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keyup', this.onKeyUp.bind(this));

      if (this.trigger) {
        this.trigger.addEventListener('click', this.onTriggerClick.bind(this));
      }
    }

    get isOpen() {
      return this.classList.contains('is-open');
    }

    onMouseEnter() {
      clearTimeout(this.closeTimer);
      this.openTimer = setTimeout(() => this.open(), 80);
    }

    onMouseLeave() {
      clearTimeout(this.openTimer);
      this.closeTimer = setTimeout(() => this.close(), 180);
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    onKeyUp(event) {
      if (event.code !== 'Escape') return;
      this.close();
      if (this.trigger) this.trigger.focus();
    }

    // On touch devices the first tap opens the panel, the second one follows the link.
    onTriggerClick(event) {
      if (!window.matchMedia('(hover: none)').matches) return;
      if (this.tapped) return;
      event.preventDefault();
      this.tapped = true;
      this.open();
    }

    open() {
      clearTimeout(this.closeTimer);
      if (this.isOpen) return;
      document.querySelectorAll('menu-cards-item.is-open').forEach((item) => {
        if (item !== this) item.close();
      });
      this.classList.add('is-open');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
    }

    close() {
      clearTimeout(this.openTimer);
      if (!this.isOpen) return;
      this.classList.remove('is-open');
      this.tapped = false;
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('menu-cards-item', MenuCardsItem);

  } catch(e) { console.error(e); }
})();
})();
